"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedL1CategoriesEntityPrefix = void 0;
var SelectedL1CategoriesEntityPrefix;
(function (SelectedL1CategoriesEntityPrefix) {
    SelectedL1CategoriesEntityPrefix["StrategyPreview"] = "STRATEGY_PREVIEW:";
    SelectedL1CategoriesEntityPrefix["StrategyMatrix"] = "STRATEGY_MATRIX:";
})(SelectedL1CategoriesEntityPrefix || (exports.SelectedL1CategoriesEntityPrefix = SelectedL1CategoriesEntityPrefix = {}));
